import { defineStore } from "pinia";
import { useUserStore } from "./user";
import { fetchCategories } from "../../api/v2/category.ts";

export const useCategoryStore = defineStore("category", {
  state: () => {
    return {
      categories: null,
    };
  },
  actions: {
    async getCategories() {
      if (!this.categories) {
        try {
          const user = useUserStore();
          const response = await fetchCategories(user.clientCode);
          if (response) {
            this.categories = response.data;
          }
        } catch (error) {
          return error;
        }
      }

      return this.categories;
    },
    getCategoryById(categoryId) {
      if (this.categories !== null) {
        return this.categories.find((category) => category.id === categoryId);
      }
    },
  },
});
